import React from "react";
import { ListItem, ListItemText, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NotSerializedBookingInputs } from "../../../../features/Booking-Form/typings/booking-inputs";

interface ConferenceServicesProps {
  inputs: NotSerializedBookingInputs;
}

export const FormConfirmConferenceServices: React.FC<ConferenceServicesProps> = ({ inputs }) => {
  const { t } = useTranslation();

  const selectedEntryId = inputs.usersBookedFor?.[0]?.bookingInventoryId;

  const conferenceEntry =
    selectedEntryId == null ? undefined : inputs.conferenceService?.[selectedEntryId];

  if (
    !selectedEntryId ||
    !conferenceEntry ||
    (conferenceEntry.caterings.length === 0 &&
      conferenceEntry.bookableEquipments.length === 0 &&
      conferenceEntry.roomLayout.length === 0)
  ) {
    return null;
  }

  const { caterings, bookableEquipments, roomLayout } = conferenceEntry;

  return (
    <ListItem>
      <ListItemText
        primary={t("Services")}
        secondary={
          <>
            {caterings.length > 0 && (
              <>
                <Typography variant="body1" sx={{ pt: 1 }}>
                  - {t("Caterings")}
                </Typography>
                <Typography variant="body2" sx={{ pl: 1.2 }}>
                  {caterings.map((catering, idx) => (
                    <div key={catering.name}>
                      {`${catering.name} (${catering.qty} × ${catering.pricePerUnit})`}
                      {idx < caterings.length - 1 && ","}
                    </div>
                  ))}
                </Typography>
              </>
            )}

            {bookableEquipments.length > 0 && (
              <>
                <Typography variant="body1" sx={{ pt: 1 }}>
                  - {t("Bookable Equipments")}
                </Typography>
                <Typography variant="body2" sx={{ pl: 1.2 }}>
                  {bookableEquipments.map((equipment, idx) => (
                    <div key={equipment.name}>
                      {equipment.name}
                      {idx < bookableEquipments.length - 1 && ","}
                    </div>
                  ))}
                </Typography>
              </>
            )}

            {roomLayout.length > 0 && (
              <>
                <Typography variant="body1" sx={{ pt: 1 }}>
                  - {t("Layout")}
                </Typography>
                <Typography variant="body2" sx={{ pl: 1.2 }}>
                  {roomLayout[0].name}
                </Typography>
              </>
            )}
          </>
        }
      />
    </ListItem>
  );
};
